import { Box, Button, Dialog, DialogFooter, DialogHeader, StickyBottom } from '@ui-lib';
import type { FormEvent, ReactNode } from 'react';

import { DeleteButton } from './DeleteButton';

interface EditDialogProps {
  icon?: ReactNode;
  title: string;
  children: ReactNode | ReactNode[];
  canDelete: boolean;
  canSubmit: boolean;
  onDelete: () => void;
  onCancel: () => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
}

export const EditDialog = ({
  title,
  children,
  canDelete,
  canSubmit,
  icon,
  onDelete,
  onCancel,
  onSubmit,
}: EditDialogProps): JSX.Element => {
  return (
    <form onSubmit={onSubmit}>
      <Dialog>
        <DialogHeader leadingIcon={icon} title={title} />
        <Box padding="medium" style={{ maxHeight: '600px', overflowY: 'auto' }}>
          {children}
        </Box>
        <StickyBottom>
          <DialogFooter>
            <Box display="flex" justifyContent="flexEnd">
              {canDelete && <DeleteButton onClick={onDelete} />}
              <Box marginLeft="auto" display="flex" gap="small">
                <Button type="button" variant="outline" onClick={onCancel}>
                  Cancel
                </Button>
                <Button type="submit" disabled={!canSubmit} variant="solid">
                  Save
                </Button>
              </Box>
            </Box>
          </DialogFooter>
        </StickyBottom>
      </Dialog>
    </form>
  );
};
